















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
// @ts-ignore
import SwaggerUI from '@/components/Documentation/SwaggerUI.vue';

@Component({ name: 'SwaggerFi', components: { SwaggerUI }, metaInfo: { title: 'FI API' } })
export default class extends SaascadaVue {

    get url() {
        return process.env.VUE_APP_FI_BASE_URL + '/openapi';
    }

}
